<!-- container-report.component.html -->
<div class="container-report-page">
  <div class="container-content">

    @if (errorMessage) {
      <div class="error">{{ errorMessage }}</div>
    }

    @if (!errorMessage) {

      <!-- TOP: container details + images -->
      <section class="top-row">
        <div class="info-panel">
          <div class="panel-title panel-title-inline panel-title-inline--table">
            <span class="panel-title-inline__label">Container</span>
            <!--
            <button type="button" class="btn btn-white btn-sm export-button panel-title-inline__action" (click)="exportContainerDetails()">
              Export Data
              <span class="svg-icon svg-icon-xs ms-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
              </span>
            </button>
            -->
          </div>

          <table class="info-table">
            <tbody>
              <tr>
                <th scope="row">CONTAINER</th>
                <td>{{ report?.assetId || '-' }}</td>
              </tr>
              <tr>
                <th scope="row">CONTAINER TYPE</th>
                <td>{{ report?.assetType || '-' }}</td>
              </tr>
              <tr>
                <th scope="row">COLOUR</th>
                <td>{{ report?.colour || '-' }}</td>
              </tr>
              <tr>
                <th scope="row">CONDITION</th>
                <td>{{ report?.condition || '-' }}</td>
              </tr>
              <tr>
                <th scope="row">WELD NO</th>
                <td>{{ report?.weldNumber || '-' }}</td>
              </tr>
              <tr>
                <th scope="row">LOCATION</th>
                <td class="location-wide">{{ report?.locationName || '-' }}</td>
              </tr>
              <tr>
                <th scope="row">STATUS</th>
                <td>{{ report?.status || '-' }}</td>
              </tr>
              <tr>
                <th scope="row">TOTAL MOVEMENTS</th>
                <td>{{ movementCount() }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- TOP RIGHT: images as thumbnails -->
        <div class="images-panel">
          <div class="panel-title">Images</div>

          @if (!thumbnails.length) {
            <div class="empty">No images available.</div>
          } @else {
            <div class="thumb-grid">
              @for (img of thumbnails; track trackByUrl($index, img)) {
                <button type="button" class="thumb-card" (click)="openPopup(img.url)">
                  <img class="thumb" [src]="img.url" [alt]="img.label" />
                </button>
              }
            </div>
          }
        </div>
      </section>
      <!-- BOTTOM: movements + damage history -->
      <section class="tables-row">

        <div class="table-panel">
          @if (movementRange.min !== null && movementRange.max !== null) {
            <div class="movement-controls">
              <div class="range-line range-line--inputs">
                <input
                  type="date"
                  class="range-date-input"
                  [min]="movementMinDateValue()"
                  [max]="movementMaxDateValue()"
                  [value]="movementFromDateValue()"
                  (input)="onMovementFromDateInput($event)"
                  [disabled]="movementRange.min === movementRange.max" />
                <span class="range-sep">to</span>
                <input
                  type="date"
                  class="range-date-input"
                  [min]="movementMinDateValue()"
                  [max]="movementMaxDateValue()"
                  [value]="movementToDateValue()"
                  (input)="onMovementToDateInput($event)"
                  [disabled]="movementRange.min === movementRange.max" />
              </div>
              <div class="range-slider">
                <div
                  class="range-fill"
                  [style.left]="movementFromPercent()"
                  [style.right]="'calc(100% - ' + movementToPercent() + ')'">
                </div>
                <input
                  type="range"
                  class="range-input range-input--from"
                  [min]="movementRange.min"
                  [max]="movementRange.max"
                  [step]="movementRangeStep"
                  [value]="movementRange.from"
                  (input)="onMovementFromInput($event)"
                  [disabled]="movementRange.min === movementRange.max" />
                <input
                  type="range"
                  class="range-input range-input--to"
                  [min]="movementRange.min"
                  [max]="movementRange.max"
                  [step]="movementRangeStep"
                  [value]="movementRange.to"
                  (input)="onMovementToInput($event)"
                  [disabled]="movementRange.min === movementRange.max" />
              </div>
            </div>
          }

          <div class="panel-header">
            <div class="panel-title">Movements</div>
            <button type="button" class="btn btn-white btn-sm export-button" (click)="exportContainerMovements()">
              Export Data
              <span class="svg-icon svg-icon-xs ms-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
              </span>
            </button>
          </div>

          <div class="table-wrap">
            <table class="grid-table movement-table">
              <thead>
                <tr>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleMovementSort('from')">
                      From
                      <span class="sort-indicator">{{ movementSortIndicator('from') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleMovementSort('departed')">
                      Departed
                      <span class="sort-indicator">{{ movementSortIndicator('departed') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleMovementSort('arrived')">
                      Arrived
                      <span class="sort-indicator">{{ movementSortIndicator('arrived') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleMovementSort('to')">
                      To
                      <span class="sort-indicator">{{ movementSortIndicator('to') }}</span>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (m of sortedMovements(); track $index) {
                  <tr>
                    <td class="wide-cell">{{ m.from || '-' }}</td>
                    <td>{{ formatDateAndTime(m.departed) || '-' }}</td>
                    <td>{{ formatDateAndTime(m.arrived) || '-' }}</td>
                    <td class="wide-cell">{{ m.to || '-' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="table-panel">
          @if (movementRange.min !== null && movementRange.max !== null) {
            <div class="movement-controls spacer" aria-hidden="true">
              <div class="range-line">-</div>
              <div class="range-slider">
                <div class="range-fill"></div>
                <input type="range" class="range-input range-input--from" />
                <input type="range" class="range-input range-input--to" />
              </div>
            </div>
          }

          <div class="panel-header">
            <div class="panel-title">Damage History</div>
            <button type="button" class="btn btn-white btn-sm export-button" (click)="exportContainerDamage()">
              Export Data
              <span class="svg-icon svg-icon-xs ms-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
              </span>
            </button>
          </div>

          <div class="table-wrap">
            <table class="grid-table damage-table">
              <thead>
                <tr>
                  <th class="date-col">
                    <button type="button" class="sort-button" (click)="toggleDamageSort('actionDate')">
                      Date
                      <span class="sort-indicator">{{ damageSortIndicator('actionDate') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleDamageSort('fault')">
                      Fault
                      <span class="sort-indicator">{{ damageSortIndicator('fault') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleDamageSort('description')">
                      Description
                      <span class="sort-indicator">{{ damageSortIndicator('description') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleDamageSort('comment')">
                      Comment
                      <span class="sort-indicator">{{ damageSortIndicator('comment') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleDamageSort('by')">
                      By
                      <span class="sort-indicator">{{ damageSortIndicator('by') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleDamageSort('image1Url')">
                      Image1
                      <span class="sort-indicator">{{ damageSortIndicator('image1Url') }}</span>
                    </button>
                  </th>
                  <th>
                    <button type="button" class="sort-button" (click)="toggleDamageSort('image2Url')">
                      Image2
                      <span class="sort-indicator">{{ damageSortIndicator('image2Url') }}</span>
                    </button>
                  </th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                @for (d of sortedDamage(); track $index) {
                  <tr>
                    <td class="date-col">{{ formatDate(d.actionDate) || '-' }}</td>
                    <td class="fault-cell">{{ d.fault || '-' }}</td>
                    <td class="desc-cell">{{ d.description || '-' }}</td>
                    <td class="comment-cell">{{ d.comment || '-' }}</td>
                    <td>{{ d.by || '-' }}</td>
                    <td>
                      @if (d.image1Url) {<button type="button" class="mini-link" (click)="openPopup(d.image1Url)" aria-label="Open image">&#128279;</button>}
                    </td>
                    <td>
                      @if (d.image2Url) {<button type="button" class="mini-link" (click)="openPopup(d.image2Url)" aria-label="Open image">&#128279;</button>}
                    </td>
                    <td>
                      @if (damageDetailsUrl) {<a class="mini-link" [href]="damageDetailsUrl" target="_blank" rel="noopener" aria-label="Damage details">&#128279;</a>}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

      </section>
    }
  </div>
</div>

<!-- Existing popup pattern -->
<app-image-popup
  [imageSrc]="selectedImage"
  [isOpen]="isPopupOpen"
  (close)="closePopup()">
</app-image-popup>
